import { RegionModel } from '@sosocio/creator/interfaces';
import ApiService from 'services/ApiService';

class RegionService extends ApiService<RegionModel> {
	constructor() {
		super('region');
	}
}

export default new RegionService();
